import { PosOrderDraftCreateInput } from '@/features/graphql/generated/graphql'
import { posOrderDraftMutation } from '@/features/pos/components/OrderFinalization/mutations'
import { logger } from '@/features/pos/logger'
import { useHandleErrorWithToast } from '@/hooks/useHandleErrorWithToast'
import { useMutation } from '@apollo/client'
import { useCallback } from 'react'

export const usePosOrderDraft = (): [
    (cartKey: string, orderData: PosOrderDraftCreateInput) => Promise<void>,
    boolean,
] => {
    const handleError = useHandleErrorWithToast(logger)

    const [posOrderDraft, { loading }] = useMutation(posOrderDraftMutation, {
        onError: handleError,
    })

    const handleOrderDraft = useCallback(
        async (cartKey: string, orderData: PosOrderDraftCreateInput) => {
            await posOrderDraft({ variables: { cartKey, orderData } })
        },
        [posOrderDraft]
    )

    return [handleOrderDraft, loading]
}
